export const GET_NEGARA_REQUEST = "@negara/GET_NEGARA_REQUEST";
export const GET_NEGARA_SUCCESS = "@negara/GET_NEGARA_SUCCESS";
export const GET_NEGARA_FAILURE = "@negara/GET_NEGARA_FAILURE";